module.exports = __webpack_public_path__ + "img/uicon.ccff59be.jpg";